import React, { useCallback } from 'react'
import { SearchInput, l } from '@manychat/manyui'

import { UserFieldType } from 'common/fields/constants/UserFieldsTypes'
import { Field } from 'common/fields/entities/field'
import { FieldList } from 'common/fields/linking/components/FieldList'
import { IRenderOptionFunction } from 'components/AutocompleteElements/OptionsList/OptionItem'
import { AllowNewField } from 'components/AutocompleteElements/OptionsList/OptionListConfig'

interface FieldSearchProps {
  autofocus?: boolean
  fields: Field[]
  onSelect: (value: string) => void
  allowNew?: AllowNewField
  hideCategories?: boolean
  showIcon?: boolean
  renderOption?: IRenderOptionFunction
  allowedUserFieldTypes?: UserFieldType[]
  trackFieldSelection?: boolean
}

const FieldSearch = ({
  autofocus,
  fields,
  onSelect,
  hideCategories,
  showIcon,
  renderOption,
  allowNew,
  allowedUserFieldTypes,
  trackFieldSelection,
}: FieldSearchProps) => {
  const [inputRef, setInputRef] = React.useState<HTMLInputElement | null>(null)
  const [query, setQuery] = React.useState('')

  const handleRef = (input: HTMLInputElement | null) => {
    setInputRef(input)
    autofocus && input?.focus()
  }

  const handleChangeQuery = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    setQuery(value)
  }, [])

  return (
    <>
      <div className="p-a-xs b-b">
        <SearchInput
          inputRef={handleRef}
          value={query}
          onChange={handleChangeQuery}
          onClear={() => setQuery('')}
          ariaLabel={l.translate('Search fields')}
        />
      </div>
      <FieldList
        query={query}
        fields={fields}
        onSelect={onSelect}
        target={inputRef}
        hideCategories={hideCategories}
        showIcon={showIcon}
        renderOption={renderOption}
        allowNew={allowNew}
        allowedUserFieldTypes={allowedUserFieldTypes}
        trackFieldSelection={trackFieldSelection}
      />
    </>
  )
}

export default FieldSearch
